import React from 'react';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.css';
import './AboutMe.scss';

const rootClass = 'about-me';
const userInfo = `${rootClass}__user-info`;
const contactClass= `${rootClass}__contact`;
const contactInfoClass = `${contactClass}__info`;

const AboutMe = ({contact, name, title, objective}) => {
	const { primaryEmail, primaryNumber, skypeId, linkedinProfile, address } = contact;
	return (
		<div className={rootClass}>
			<div className={userInfo}>
				<h2 className={`${userInfo}__name`}>
					{name}
				</h2>
				<h3 className={`${userInfo}__role`}>
					{title}
				</h3>
				<p className={`${userInfo}__objective`}>
					{objective}
				</p>
			</div>
			<div className={`${rootClass}__avatar`}>
				<img src="https://secure.gravatar.com/avatar/ba8b21e8aa2d317e4b33e7253d787903?size=200" className={`${rootClass}__avatar__img`} alt="harndra singh bisht" />
			</div>
			<div className={contactClass}>
				{primaryEmail && <div className={`${contactInfoClass} ${contactInfoClass}--email`}>{primaryEmail} </div>}
				<div className={`${contactInfoClass} ${contactInfoClass}--mobile`}>{primaryNumber} </div>
				{linkedinProfile && <div className={`${contactInfoClass} ${contactInfoClass}--linkedin`}><a href={linkedinProfile} target="_blank">{linkedinProfile}</a></div>}
				<div className={`${contactInfoClass} ${contactInfoClass}--address`}>{address} </div>
				<div className={`${contactInfoClass} ${contactInfoClass}--skype`}>{skypeId} </div>
			</div>
		</div>
	);
}

AboutMe.propTypes = {
	contact: PropTypes.object,
	name: PropTypes.string,
	title: PropTypes.string,
	objective: PropTypes.string,
};

export default AboutMe;